"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITOP_CONTRACT_STATUS = exports.ITOP_CONTRACT_CURRENCY = void 0;
exports.ITOP_CONTRACT_CURRENCY = {
    PESOS: 'Pesos',
    UF: 'UF',
    DOLLARS: 'dollars',
    EUROS: 'euros',
};
exports.ITOP_CONTRACT_STATUS = {
    IMPLEMENTATION: 'implementation',
    OBSOLETE: 'obsolete',
    PRODUCTION: 'production',
};
